import { useStaticQuery, graphql } from 'gatsby'

const secundarioMetadata = () => {
  const { allWpMenuItem } = useStaticQuery(
    graphql`
      query MenuSecundario {
        allWpMenuItem(filter: { locations: { eq: SECUNDARIO } }, limit: 300) {
          edges {
            node {
              url
              label
              url
              order
              id
              parentId
              connectedNode {
                node {
                  uri
                }
              }
              childItems {
                nodes {
                  label
                  url
                  order
                  id
                  parentId
                  connectedNode {
                    node {
                      uri
                    }
                  }
                  childItems {
                    nodes {
                      url
                      label
                      order
                      url
                      id
                      parentId
                      connectedNode {
                        node {
                          uri
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return allWpMenuItem.edges
}
export default secundarioMetadata
